import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import dppImage from "../../assets/dpp.jfif";
import Plg from "./plg";
import TopBar from "./topbar";
import PowerBankDetails from "./PowerBankDetails";
import DigitalPassportParent from "./DigitalPassportParent";
import DesktopTimelineSlider from "./DesktopTimelineSlider";
import VerticalTimeline from "./VerticalTimeline";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from '@mui/icons-material/Search';
import LoginIcon from '@mui/icons-material/Login';


import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Modal,
  Tooltip,
} from "@mui/material";

// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";

// React-Select component and styling
import Select from "react-select";
import {
  // getSubModulesByRoleId,
  getProductsListForDpp,
  getAllDataForDpp,
  getTechnicalDocuments,
  getDurability,
  getPackagingWasteManagement,
  getRawMaterial,
  getEnvironmental,
  getChainOfCustody,
  getManufacturing,
  getRepairMaintenance,
  getItemsDetailsByDppId,
  getTreeMap,
  // getUsageHistory,
} from "../../store";

import Config from "../../config/index";
import {
  fetchDppDocumentUrl,
  fetchDppSection as fetchDppSectionService,
} from "./dppApiService";

import { connect } from "react-redux"; // Cookies
import Cookies from "universal-cookie";
import JourneyTimeline from "./journeyTimeline";
import RepairRecycleModal from "./RepairInfo";

import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import MDButton from "components/MDButton";

import Card from "@mui/material/Card";
import Operations from "./operations";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";
import DppmobileView from "./dppmobileView";
import DppDesktopView from "./dppDesktopView";

const cookies = new Cookies();

const styleForItemsViewModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  maxHeight: "90%",
  overflow: "auto",
  width: { xs: 350, lg: 1100 },
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const DppLayout = ({
  title = "Digital Product Passport",
  subtitle = "Compliance Literacy & Compliance Tracking",
  placeholder = "Search stages, certifications...",
  initialLayout = "horizontal",
  onSearch,
  onLayoutChange,
  onExport,
  getProductsListForDpp,
  getProductsListForDppReducer,
  getAllDataForDpp,
  getAllDataForDppReducer,
  getTechnicalDocuments,
  getTechnicalDocumentsReducer,
  getDurability,
  getDurabilityReducer,
  // getSubModulesByRoleId,
  // getSubModulesByRoleIdReducer,
  getItemsDetailsByDppId,
  getItemsDetailsByDppIdReducer,
  getTreeMap,
  getTreeMapReducer,
  // getUsageHistory,
  // getUsageHistoryReducer,
}) => {
  const formatFloat = (value, decimals = 2) => {
    if (typeof value === "number") {
      return value.toFixed(decimals);
    }
    if (typeof value === "string") {
      const num = parseFloat(value);
      return isNaN(num) ? value : num.toFixed(decimals);
    }
    return value;
  };
  const baseUrl = Config.baseUrl;
  const loginDetails = cookies.get("loginDetailsForWMS") || {};
  // console.log("loginDetails", loginDetails);

  const jwtToken = loginDetails?.jwt;

  const roleId = loginDetails?.data?.roleId;
  const roleName = loginDetails?.data?.roleName || "";

  const isLoggedIn = Boolean(jwtToken);

  const { pathname, search } = useLocation();
  const parsedQueryParams = useMemo(() => new URLSearchParams(search), [search]);
  const urlDppId = parsedQueryParams.get("dppId") || parsedQueryParams.get("dppid");
  const urlDppCode = parsedQueryParams.get("dppCode") || parsedQueryParams.get("dppcode");
  const urlLabel = parsedQueryParams.get("label");
  const hasDppId = Boolean(urlDppId) || Boolean(urlDppCode);
  const isFromQRCode = useMemo(
    () => pathname.toLowerCase() === "/dpp" && hasDppId,
    [pathname, hasDppId],
  );

  const handleViewMoreInfo = () => {
    try {
      let targetUrl = "";

      if (pathname.toLowerCase().startsWith("/dpp")) {
        targetUrl = pathname + search;
      } else {
        const encodedString = pathname.substring(1);
        targetUrl = atob(encodedString);
      }

      localStorage.setItem("dppRedirectUrl", targetUrl);
      navigate('/login');

    } catch (error) {
      // console.error("URL redirect fail ho gaya:", error);
      navigate('/login');
    }
  };

  const viewAccess = isFromQRCode ? true : true;
  const digitalPassportModule = viewAccess;



  const downloadReport = isFromQRCode ? true : true;
  const hasFetchedRef = useRef(false);

  const [isSearchOpenMobile, setIsSearchOpenMobile] = useState(false);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    if (typeof getProductsListForDpp === "function") {
      getProductsListForDpp(jwtToken);
    }
  }, [getProductsListForDpp, jwtToken]);

  const [productImage, setProductImage] = useState(null);
  const lastRequestedImageKeyRef = useRef("");

  const handleDocumentClickForDppImage = useCallback(
    async (productImage) => {
      const moduleName = productImage?.moduleName?.toString().trim();
      const name = productImage?.name?.toString().trim();
      const type = productImage?.type?.toString().trim();
      const requestKey = `${moduleName}|${name}|${type}`;

      if (!moduleName || !name || !type) {
        setProductImage(null);
        lastRequestedImageKeyRef.current = "";
        return;
      }

      if (lastRequestedImageKeyRef.current === requestKey) {
        return;
      }

      lastRequestedImageKeyRef.current = requestKey;

      try {
        const data = await fetchDppDocumentUrl({
          baseUrl,
          moduleName,
          name,
          type,
        });
        setProductImage(data?.data ?? null);
      } catch (error) {
        console.error("Error loading DPP image:", error);
        setProductImage(null);
      }
    },
    [baseUrl],
  );



  const [documentTypeSelected, setDocumentTypeSelected] = useState("");


  const productsListForDppOptions = useMemo(() => {
    const data = getProductsListForDppReducer?.productsListForDpp?.data || [];

    return data.map((productsListForDpp) => ({
      label: productsListForDpp.dppCode,
      value: productsListForDpp.dppId,
      serialNo: productsListForDpp.serialNo,
      version: productsListForDpp.version,
      industryId: productsListForDpp.industryId, // add this
    }));
  }, [getProductsListForDppReducer]);

  const handleDocumentTypeChange = useCallback((selectedValue) => {
    setDocumentTypeSelected(selectedValue);
  }, []);
  ;



  useEffect(() => {
    if (productsListForDppOptions?.length > 0) {
      let matchedOption = null;

      if (urlDppId || urlDppCode) {
        matchedOption = productsListForDppOptions.find(
          (item) =>
            (urlDppId && String(item.value) === String(urlDppId)) ||
            (urlDppCode && String(item.label) === String(urlDppCode))
        );
      }

      if (matchedOption) {
        setDocumentTypeSelected(matchedOption);
      } else if (urlDppId || urlDppCode) {
        setDocumentTypeSelected({
          value: urlDppId || "",
          label: urlDppCode || urlLabel || `Product ${urlDppId}`,
        });
      } else {
        setDocumentTypeSelected(productsListForDppOptions[0]);
      }
    }
  }, [productsListForDppOptions, urlDppId, urlDppCode, urlLabel]);


  const lastRequestedDppRef = useRef("");

  useEffect(() => {
    if (documentTypeSelected?.label) {
      getAllDataForDpp(documentTypeSelected.label, jwtToken);
    }
  }, [documentTypeSelected?.label, getAllDataForDpp, jwtToken]);


  useEffect(() => {
    if (documentTypeSelected?.label) {
      getTreeMap(documentTypeSelected.label, jwtToken);
    }
  }, [documentTypeSelected?.label, getTreeMap, jwtToken]);



  const handleViewClick = () => {
    const matchedOption = productsListForDppOptions?.find(
      (item) => item.value === selectedMaterialData?.dppId,
    );

    if (!matchedOption) return;

    const url = `${window.location.pathname}?dppId=${matchedOption.value}&label=${encodeURIComponent(
      matchedOption.label,
    )}`;

    window.open(url, "_blank", "noopener,noreferrer");
  };
  const mainData = useMemo(
    () => getAllDataForDppReducer?.dpp?.data || {},
    [getAllDataForDppReducer],
  );

  const treeMapData = useMemo(() => {
    const mapState = getTreeMapReducer?.treeMapData;

    if (mapState && mapState.data) {
      return mapState.data;
    }
    return mapState || {};
  }, [getTreeMapReducer]);

  const [sidebarLoading, setSidebarLoading] = useState(false);



  const mainProductImage = mainData?.mainCard?.productImage || null;



  useEffect(() => {
    if (mainProductImage) {
      handleDocumentClickForDppImage(mainProductImage);
    }
  }, [mainProductImage, handleDocumentClickForDppImage]);

  const loadDppSidebarSection = useCallback(
    async (route, options = {}) => {
      if (!documentTypeSelected?.label) return null;
      setSidebarLoading(true);
      try {
        const response = await fetchDppSectionService({
          baseUrl,
          roleName,
          route,
          dppId: documentTypeSelected.value,
          dppCode: documentTypeSelected.label,
          jwtToken,
          ...options,
        });
        return response?.data ?? null;
      } catch (error) {
        // console.error(`Error fetching ${route}:`, error);
        return null;
      } finally {
        setSidebarLoading(false);
      }
    },
    [baseUrl, documentTypeSelected?.label, jwtToken, roleName],
  );

  const openStepForTechnicalDocuments = useCallback(async () => {
    const data = await loadDppSidebarSection("technical_documents_bydpp");
    if (data) setActiveStep(data);
    setOpenSide(true);
  }, [loadDppSidebarSection]);

  const openStepForDurability = useCallback(async () => {
    const data = await loadDppSidebarSection("durability_bydpp");
    if (data) setActiveStep(data);
    setOpenSide(true);
  }, [loadDppSidebarSection]);

  const openStepForEvt = useCallback(async () => {
    const data = await loadDppSidebarSection("environmental");
    if (data) setActiveStep(data);
    setOpenSide(true);
  }, [loadDppSidebarSection]);


  const openStepForhistoryUsage = useCallback(async () => {
    const data = await loadDppSidebarSection("product_usage_history", {
    });

    if (data) setActiveStep(data);
    setOpenSide(true);
  }, [loadDppSidebarSection]);




  const openStepForProductTests = useCallback(async () => {
    const data = await loadDppSidebarSection("product_testing");
    if (data) {
      setActiveStep(data);
      setItemsDataForProductTest(data);
    }
    setOpenSide(true);
  }, [loadDppSidebarSection]);

  const openStepForCOC = useCallback(async () => {
    const data = await loadDppSidebarSection("coc");
    if (data) setActiveStep(data);
    setOpenSide(true);
  }, [loadDppSidebarSection]);

  const openStepForManufacturing = useCallback(async () => {
    const data = await loadDppSidebarSection("manufacturing");
    if (data) setActiveStep(data);
    setOpenSide(true);
  }, [loadDppSidebarSection]);

  const openStepForRawMaterial = useCallback(async () => {
    if (!documentTypeSelected?.value) return;
    setSidebarLoading(true);
    try {
      const [rawData, rmTraceData] = await Promise.all([
        fetchDppSectionService({
          baseUrl,
          roleName,
          route: "raw_material",
          dppId: documentTypeSelected.value,
          jwtToken,
        }),
        fetchDppSectionService({
          baseUrl,
          roleName,
          route: "dpp_id_for_item_details",
          dppId: documentTypeSelected.value,
          jwtToken,
          basePath: "/dpp/rm_traceability",
        }),
      ]);

      if (rawData?.data) setActiveStep(rawData.data);
      if (rmTraceData?.data) setItemsDataForRM(rmTraceData.data);
    } catch (error) {
      // console.error("Error fetching raw material section:", error);
    } finally {
      setSidebarLoading(false);
    }

    setOpenSide(true);
  }, [baseUrl, documentTypeSelected?.value, jwtToken, roleName]);

  const openStepForPWM = useCallback(async () => {
    const data = await loadDppSidebarSection("packaging_waste_management");
    if (data) setActiveStep(data);
    setOpenSide(true);
  }, [loadDppSidebarSection]);

  const openStepForRCV = useCallback(async () => {
    const data = await loadDppSidebarSection("repair_recycle_value");
    if (data) setActiveStep(data);
    setOpenSide(true);
  }, [loadDppSidebarSection]);

  function closeSidebar() {
    setOpenSide(false);
    setSidebarLoading(false);
  }

  const steps = [
    {
      id: 1,
      title: "Raw Material Sourcing",
      badgeColor: "#A78BFA",
      icon: "mountain",
      desc: "Dummy description",
      tags: "Completed",
    },
    {
      id: 2,
      title: "Manufacturing",
      badgeColor: "#60A5FA",
      icon: "factory",
      desc: "Dummy description",
    },
    {
      id: 3,
      title: "Manufacturing",
      badgeColor: "#60A5FA",
      icon: "factory",
      desc: "Dummy description",
    },
    {
      id: 4,
      title: "Manufacturing",
      badgeColor: "#60A5FA",
      icon: "factory",
      desc: "Dummy description",
    },
  ];
  const [openSide, setOpenSide] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState({});
  const [itemsDataForRM, setItemsDataForRM] = React.useState([]);
  const [itemsDataForProductTest, setItemsDataForProductTest] = React.useState(
    [],
  );



  const productData = {
    image: "https://via.placeholder.com/300",
    badge: "Very Good",
    title: "VoltGo 10000 mAh Power Bank",
    sku: "PWM-510",
    category: "Portable Electronics",
    manufacturer: "Bentrix Tech Pvt Ltd",
    origin: "China",
    score: 79,
    recycledContent: 32,
    durabilityScore: 8.6,
    carbonFootprint: 2.6,
    lifespan: 3,
    materials: "Aluminum shell, lithium-ion cells, recycled copper wiring",
    chargingCycles: "500+",
    recyclableMaterials: 78,
    energyConsumption: 4.8,
    certifications: [
      { label: "ISO 14001", color: "green" },
      { label: "Carbon Neutral", color: "blue" },
      { label: "ESG Certified", color: "purple" },
    ],
  };

  const [query, setQuery] = useState("");
  const [layout, setLayout] = useState(
    initialLayout === "vertical" ? "vertical" : "horizontal",
  );

  const searchTimer = useRef(null);

  useEffect(() => {
    return () => {
      if (searchTimer.current) clearTimeout(searchTimer.current);
    };
  }, []);

  function handleQueryChange(e) {
    const v = e.target.value;
    setQuery(v);

    // debounce 300ms before calling onSearch
    if (searchTimer.current) clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      if (typeof onSearch === "function") onSearch(v);
    }, 300);
  }

  function toggleLayout(newLayout) {
    if (newLayout === layout) return;
    setLayout(newLayout);
    if (typeof onLayoutChange === "function") onLayoutChange(newLayout);
  }

  function handleExport() {
    if (typeof onExport === "function") onExport();
  }



  const styles = useMemo(
    () => ({
      bar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 16px",
        background: "#0db26b",
        color: "white",
        gap: 12,
        // width: "100%",
        boxSizing: "border-box",
        borderRadius: "10px",
        marginTop: "10px",
        flexWrap: "nowrap",
      },
      left: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        // minWidth: "250px",
        minWidth: 0,
        flex: 1,
      },
      logoBox: {
        width: 44,
        height: 44,
        borderRadius: 6,
        background: "rgba(255,255,255,0.12)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: 14,
      },
      titles: {
        display: "flex",
        flexDirection: "column",
        lineHeight: 1,
      },
      title: { fontSize: 16, fontWeight: 700 },
      subtitle: { fontSize: 12, opacity: 0.9 },

      right: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
        flex: "1 1 auto",
        justifyContent: "flex-end",
      },
      search: {
        display: "flex",
        alignItems: "center",
        background: "white",
        color: "#111827",
        borderRadius: 8,
        padding: "6px 8px",
        minWidth: 260,
        maxWidth: 520,
        boxShadow: "rgba(0,0,0,0.08) 0 1px 3px",
      },
      input: {
        border: "none",
        outline: "none",
        fontSize: 13,
        marginLeft: 8,
        width: "100%",
        background: "transparent",
      },
      controls: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
      },
      btn: {
        background: "rgba(255,255,255,0.12)",
        color: "white",
        border: "none",
        padding: "8px 10px",
        borderRadius: 6,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: 13,
      },
      toggleBtn: (active) => ({
        background: active ? "white" : "transparent",
        color: active ? "#111827" : "white",
        border: "none",
        padding: 8,
        borderRadius: 6,
        cursor: "pointer",
      }),
      icon: { width: 16, height: 16, display: "inline-block" },
    }),
    [],
  );


  const isTabletOrMobile =
    typeof window !== "undefined" ? window.innerWidth <= 1024 : false;

  const [verticalTab, setVerticleTab] = useState(isTabletOrMobile);

  useEffect(() => {
    let resizeTimer = null;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        const isMobile = window.innerWidth <= 1024;
        setVerticleTab(isMobile);
        setLayout(isMobile ? "vertical" : "horizontal");
      }, 150);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.clearTimeout(resizeTimer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  const handleIframeLoad = () => {
    setIsLoading(false);
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState("");
  const [isPDF, setIsPDF] = useState(false);


  const handleDocumentClick = useCallback(
    async (documentDetails) => {
      if (!documentDetails) return;
      setOpenDialog(true);
      setIsLoading(true);

      try {
        const data = await fetchDppDocumentUrl({
          baseUrl,
          moduleName: documentDetails.moduleName,
          name: documentDetails.name,
          type: documentDetails.type,
        });

        let url = data?.data;
        if (!url) {
          throw new Error("Document URL missing from response");
        }

        setDownloadUrl(url);

        if (url.endsWith("pdf")) {
          setIsPDF(true);
          setSelectedDocumentUrl(
            `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`,
          );
        } else {
          setIsPDF(false);
          setSelectedDocumentUrl(url);
        }
      } catch (error) {
        console.error("Error loading document:", error);
        setSelectedDocumentUrl("");
        setDownloadUrl("");
      } finally {
        setIsLoading(false);
      }
    },
    [baseUrl],
  );

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setIsLoading(true);
    setIsPDF(true);
  };

  const [openMaterialModal, setOpenMaterialModal] = useState(false);
  const [testType, setTestType] = useState("");
  const [selectedMaterialData, setSelectedMaterialData] = useState(null);



  const { dppId } = useParams();
  const navigate = useNavigate();


  const [viewItemsData, setViewItemsData] = useState("");

  const [viewItemsTableForTensile, setViewItemsTableForTensile] = useState({
    columns: [
      { Header: "Yield Test Name", accessor: "yiTestName" },
      { Header: "Yield Methodology", accessor: "yiMethodology", width: 200 },
      {
        Header: "Yield Proof Strength Mean",
        width: 300,
        accessor: "yeildProofStrengthMean",
      },
      { Header: "Yield LL", accessor: "yieldLL" },
      { Header: "Yield UL", accessor: "yieldUL" },
      { Header: "Yield UOM", accessor: "yieldUOM" },
      { Header: "Tensile Test Name", accessor: "teTestName" },
      { Header: "Tensile Methodology", accessor: "teMethodology", width: 300 },
      {
        Header: "Tensile Strength Mean",
        accessor: "tensileStrengthMean",
        width: 300,
      },
      { Header: "Tensile LL", accessor: "tensileLL" },
      { Header: "Tensile UL", accessor: "tensileUL" },
      { Header: "Tensile UOM", accessor: "tensileUOM" },
      { Header: "Impact Test Name", accessor: "imTestName" },
      { Header: "Impact Methodology", accessor: "imMethodology" },
      {
        Header: "Notch Impact Strength Mean",
        accessor: "notchimpactStrengthMean",
        width: 300,
      },
      { Header: "Impact LL", accessor: "impactLL" },
      { Header: "Impact UL", accessor: "impactUL" },
      { Header: "Impact UOM", accessor: "impactUOM" },
    ],
    rows: [],
  });

  const [viewItemsTableForHardness, setViewItemsTableForHardness] = useState({
    columns: [
      { Header: "HR Test Name", accessor: "hrTestName", align: "left" },
      {
        Header: "HR Methodology",
        accessor: "hrMethodology",
        align: "left",
        width: 300,
      },
      { Header: "Hardness Mean", accessor: "hardnessMean", align: "left" },
      { Header: "HRC LL", accessor: "hrcLL", align: "left" },
      { Header: "HRC UL", accessor: "hrcUL", align: "left" },
      { Header: "HR UOM", accessor: "hrUOM", align: "left" },
      { Header: "HB Test Name", accessor: "hbTestName", align: "left" },
      {
        Header: "HB Methodology",
        accessor: "hbMethodology",
        align: "left",
        width: 300,
      },
      {
        Header: "Hardness Individual Values",
        accessor: "hardnessIndividualValues",
        align: "left",
        width: 300,
      },
      { Header: "HB LL", accessor: "hbLL", align: "left" },
      { Header: "HB UL", accessor: "hbUL", align: "left" },
      { Header: "HB UOM", accessor: "hbUOM", align: "left" },
    ],
    rows: [],
  });

  const [viewItemsTableForNotchimpact, setViewItemsTableForNotchimpact] =
    useState({
      columns: [
        {
          Header: "Impact Test Name",
          accessor: "impactTestName",
          align: "left",
        },
        {
          Header: "Impact Methodology",
          accessor: "impactMethodology",
          align: "left",
          width: 300,
        },
        {
          Header: "Notch Impact Strength Mean",
          accessor: "notchimpactStrengthMean",
          align: "left",
          width: 300,
        },
        { Header: "CH LL", accessor: "chLL", align: "left" },
        { Header: "CH UL", accessor: "chUL", align: "left" },
        { Header: "CH UOM", accessor: "chUOM", align: "left" },
      ],
      rows: [],
    });

  const { columns, rows } =
    (testType == "tensileTest" && viewItemsTableForTensile) ||
    (testType == "hardnessTest" && viewItemsTableForHardness) ||
    (testType == "notchimpactTest" && viewItemsTableForNotchimpact);

  const [openViewItemsModal, setOpenViewItemsModal] = useState(false);

  const handleOpenViewItemsModal = (data) => {
    setViewItemsData(data);
    setOpenViewItemsModal(true);
  };

  const handleCloseViewItemsModal = () => {
    setOpenViewItemsModal(false);
  };


  const hasIndustryId = documentTypeSelected?.industryId === 1;
  const hasSteelIndustry = documentTypeSelected?.industryId === 9;
  const hasBatteryIndustry = documentTypeSelected?.industryId === 10;

  // console.log("hasIndustryId", hasIndustryId);

  const showSidebar = isLoggedIn;
  const Wrapper = showSidebar ? DashboardLayout : React.Fragment;
  return (
    <Wrapper>
      {showSidebar && <DashboardNavbar />}
      <div className="dpp-app">
        <style>{`
                :root{
                    --green:#0db26b;
                    --blue:#0466f7;
                    --muted:#6b7280;
                    --card:#ffffff;
                    --bg:#f6fbff;
                    --glass: rgba(255,255,255,0.9);
                    --accent:#7c3aed;
                    font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
                }

                .dpp-app{
                    min-height:100vh;
                    background: linear-gradient(180deg,#e6f7ef 0%, #f6fbff 100%);
                    padding-top:20px;
                }

                /* Responsive Overrides */
            @media (max-width: 900px) {
                .sidebar-panel-new { width: 100% !important; }
                .card { flex-direction: column !important; width: 100% !important; }
                .left-col, .right-col { width: 100% !important; }
            }

 /* sidebar panel */
                .sidebar-panel-overlay { position:fixed; inset:0; background:rgba(2,6,23,0.35); z-index:1200; opacity:0; pointer-events:none; transition:opacity 180ms ease; }
                .sidebar-panel-overlay.open { opacity:1; pointer-events:auto; }
                .sidebar-panel {
                  position:fixed;
                  top:60px;
                  right:20px;
                  width:380px;
                  max-width:92%;
                  background:var(--card);
                  border-radius:12px;
                  padding:16px;
                  box-shadow: 0 18px 40px rgba(2,6,23,0.18);
                  z-index:1250;
                  transform: translateX(110%);
                  transition: transform 240ms cubic-bezier(.2,.9,.2,1);
                  font-size:14px;
                }
                .sidebar-panel.open { transform: translateX(0%); }
                .sidebar-panel .close { position:absolute; top:10px; right:10px; background:transparent;border:0; font-weight:700; cursor:pointer; }
                .sidebar-panel h4 { margin:0 0 8px 0; font-size:16px; }
                .sidebar-panel .meta { color:var(--muted); font-size:13px; margin-bottom:8px; }
                .sidebar-panel .section { margin-top:10px; padding-top:8px; border-top:1px dashed #eef2ff; }
                .topbar{
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    width:102.1%;
                    margin-left:-18px;
                    background:var(--green);
                    color:white;
                    border-radius:8px;
                    padding:12px 20px;
                    box-shadow: 0 4px 10px rgba(3,64,3,0.08);
                }

                .brand{
                    display:flex;
                    gap:12px;
                    align-items:center;
                    font-weight:600;
                }

                .brand .logo{
                    width:36px;height:36px;border-radius:6px;background:rgba(255,255,255,0.2);
                    display:flex;align-items:center;justify-content:center;font-weight:700;
                }

                .search{
                    display:flex;align-items:center;gap:8px;background:rgba(255,255,255,0.12);padding:6px 10px;border-radius:8px;
                    min-width:360px;
                }

                .search input{
                    border:0;background:transparent;color:white;outline:none;width:100%;
                }

                .top-actions{display:flex;gap:8px;}

                .toggle{
                    background:rgba(255,255,255,0.18);padding:6px 10px;border-radius:999px;color:white;font-weight:600;
                }

                .dpp-container{
                   
                    display:flex;
                    
                    align-items:flex-start;
                    background: "white"
                    height:"fit-content";
                }

                .sidebar{
                    width:220px;
                    background:linear-gradient(180deg,#0477e3,#2b8fff);
                    color:white;
                    border-radius:10px;
                    padding:14px;
                    box-shadow:0 6px 16px rgba(2,50,120,0.08);
                }

                .sidebar h3{margin:0 0 8px 0;font-size:14px}
                .sidebar .pill{background:rgba(255,255,255,0.12);padding:6px 8px;border-radius:6px;font-size:12px;display:inline-block}

                .main{
                    flex:1;
                }

                .card{
                    display:flex;
                    width:100%;
                    
                      margin-top: 12px;
                    background: #fff;
                    width: "fit-content";
                    border-radius: 10px;
                    padding: 6px 12px;
                    box-shadow: 0 8px 20px rgba(2,6,23,0.04);
                    text-align: center;
                }

                .left-col{
                    width:360px;
                    display:flex;
                    flex-direction:column;
                    gap:12px;
                }

                .product-image{
                    height:260px;
                    border-radius:8px;
                    overflow:hidden;
                    background:linear-gradient(135deg,#f3f6fb,#eef7ff);
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    position:relative;
                }

                .product-image img{max-width:100%;max-height:100%;object-fit:cover}

                .badge-very{
                    position:absolute;
                    top:12px;left:12px;
                    background:linear-gradient(180deg,#0ea5a4,#06b6d4);
                    color:white;padding:6px 10px;border-radius:999px;font-weight:600;font-size:12px;
                    box-shadow:0 6px 12px rgba(14,165,164,0.14);
                }

                .image-caption{
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    gap:8px;
                    font-size:13px;
                    color:var(--muted);
                }

                .right-col{
                    flex:1;
                    display:flex;
                    flex-direction:column;
                    gap:12px;
                }

                .title-row{
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    gap:12px;
                }

                .product-title{
                    font-size:18px;font-weight:700;color:#0f172a;
                }

                .tags{display:flex;gap:8px;flex-wrap:wrap}

                .tag{
                    background:#f1f5f9;border-radius:999px;padding:6px 10px;font-size:12px;color:#0f172a;border:1px solid #eef2ff;
                }

                .meta{color:var(--muted);font-size:13px;margin-top:6px}

                .score-card{
                    display:flex;gap:18px;align-items:center;padding:14px;border-radius:8px;background:linear-gradient(90deg,#f8fafc,#ffffff);
                    border:1px solid #eef2ff;
                }

                .score-circle{
                    width:96px;height:96px;border-radius:50%;display:flex;align-items:center;justify-content:center;
                    font-weight:700;background:conic-gradient(#00a3ff 0% 79%, #e6eefb 79% 100%);
                    color:#0f172a;
                }

                .score-details{flex:1}

                .score-bar{
                    height:10px;background:#eef2ff;border-radius:999px;overflow:hidden;margin:6px 0;
                }

                .bar-inner{height:100%;background:linear-gradient(90deg,#00a3ff,#7c3aed);width:0%;transition:width 600ms ease}

                .info-grid{
                    display:grid;
                    grid-template-columns:1fr 1fr;
                    gap:10px;
                    margin-top:6px;
                }

                .info-item{background:#f8fafc;padding:10px;border-radius:8px;font-size:13px;color:#0f172a}

                .quick-stats{display:flex;gap:8px;flex-wrap:wrap;margin-top:10px}

                .stat-pill{background:#fff7ed;border:1px solid #ffedd5;padding:8px 10px;border-radius:8px;font-size:13px;color:#92400e}

                .actions{display:flex;gap:12px;margin-top:12px;align-items:center}

                .btn-primary{background:var(--blue);color:white;padding:10px 16px;border-radius:8px;border:0;font-weight:700;cursor:pointer;box-shadow:0 6px 14px rgba(4,102,247,0.16)}
                .btn-ghost{background:white;border:1px solid #eef2ff;padding:10px;border-radius:8px;cursor:pointer}

                .bottom-tags{display:flex;gap:8px;margin-top:12px;flex-wrap:wrap}
                .pill-small{background:#eef2ff;padding:6px 10px;border-radius:999px;color:#0f172a;font-weight:600;font-size:12px}


                
            `}</style>

        <style>{`
                .plg-container {
                    font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
                    background: "white";
                    border: 1px solid rgba(59,130,246,0.08);
                    border-radius: 12px;
                    padding: 20px;
                    box-shadow: 0 6px 18px rgba(2,6,23,0.06);
                }
                .plg-header h3 { margin: 0; font-size: 18px; color: #0f172a; }
                .plg-header small { color: #6b7280; }

                .timeline-wrap { position: relative; margin-top: 20px; padding: 36px 12px 20px; background: transparent; }
                .timeline-line {
                    position: absolute;
                    left: 48px;
                    right: 48px;
                    top: 72px;
                    height: 6px;
                    background: linear-gradient(90deg,#bbdefb,#c8f7e6);
                    border-radius: 4px;
                    filter: blur(0.2px);
                }

                .steps {
                    display: flex;
                    gap: 40px;
                    align-items: flex-start;
                    justify-content: space-between;
                    position: relative;
                }
                .step {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: "fit-content";
                    min-width: 140px;
                }

                .icon-wrap { position: relative; margin-bottom: 12px; }
                .icon-circle {
                    width: 86px;
                    height: 86px;
                    border-radius: 50%;
                    background: linear-gradient(180deg,#05b85b,#00b74a);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 6px 20px rgba(3,102,67,0.12), inset 0 4px 0 rgba(255,255,255,0.12);
                }
                .icon-circle svg { display: block; }

                .step-number {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    background: #fff;
                    border: 3px solid rgba(99,102,241,0.8);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 600;
                    color: #374151;
                    box-shadow: 0 4px 10px rgba(2,6,23,0.08);
                }

                .card {
                    margin-top: 12px;
                    background: #fff;
                    width: "fit-content";
                    border-radius: 10px;
                    padding: 6px 12px;
                    box-shadow: 0 8px 20px rgba(2,6,23,0.04);
                    text-align: center;
                }

                .card-title { color: #0f172a; font-weight: 600; margin-bottom: -5px; font-size: 14px; width: fit-content; margin-left: auto; margin-right: auto; }
                .pill {
                    display: inline-block;
                    padding: 5px;
                    border-radius: 10px;
                    font-size: 12px;
                    border: 2px solid;
                    background: rgba(255,255,255,0.98);
                    font-weight: 600;
                }

                /* responsive */
                @media (max-width: 900px) {
                    .steps { gap: 24px; overflow-x: auto; padding-bottom: 8px; }
                    .timeline-line { left: 16px; right: 16px; top: 116px; }
                }

                
            `}</style>

        <style>{` 
            @media (max-width: 950px) {
              .dpp-topbar {
                flex-wrap: wrap !important;  
                height: auto !important;
                padding: 15px !important;
              }
              .dpp-topbar-left {
                flex-shrink: 0 !important; 
                margin-bottom: 12px !important;  
              }
              .dpp-header-titles {
                white-space: nowrap !important;  
              }
              .dpp-topbar-right {
                width: 100% !important; 
                justify-content: flex-start !important;
                gap: 15px !important;
                flex-wrap: wrap !important;
              }
              .dpp-search-box {
                flex: 1 !important;  
                min-width: 200px !important;
              }
            }

             
            @media (max-width: 600px) {
              .mobile-hide-toggle {
                display: none !important;
              }
            }
          `}</style>


        <div
          className="dpp-topbar"
          style={{
            ...styles.bar,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 14px",
            overflow: "visible",
            flexWrap: "nowrap",
            width: "100%",
            marginLeft: 0,
            marginTop: 0,
            boxSizing: "border-box",
            zIndex: 10,
          }}
          role="banner"
          aria-label="Top bar"
        >
          <style>{`
            .mobile-search-overlay {
              position: absolute;
              top: 0; left: 0; width: 100%; height: 100%;
              background: #0db26b; z-index: 20;
              display: flex; align-items: center; padding: 0 14px; gap: 8px; 
              opacity: 0; 
              visibility: hidden; 
              pointer-events: none;
              transition: opacity 0.3s ease, visibility 0.3s ease;
              border-radius: 10px;
            }
            .mobile-search-overlay.open { 
              opacity: 1; 
              visibility: visible; 
              pointer-events: auto; 
            }
             
            .desktop-search-wrap { 
               display: none; 
               width: 300px; 
               min-width: 250px; 
            }
            .mobile-search-trigger { display: block; }
            
            @media (min-width: 950px) {
              .desktop-search-wrap { display: block; }
              .mobile-search-trigger { display: none; }
            }
          `}</style>

          {/* LEFT SIDE: Texts */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flex: 1,
              minWidth: 0,
              opacity: isSearchOpenMobile ? 0 : 1,
              transition: "opacity 0.2s"
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: 700, color: "white", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {title}
              </span>
              <span style={{ fontSize: "12px", color: "white", opacity: 0.9, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {subtitle}
              </span>
            </div>

            {/* Mobile Left Search Icon */}
            {isLoggedIn && (
              <div className="mobile-search-trigger" style={{ flexShrink: 0 }}>
                <IconButton
                  onClick={() => setIsSearchOpenMobile(true)}
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    color: "white",
                    borderRadius: "8px",
                    width: "40px",
                    height: "40px",
                    marginLeft: "8px"
                  }}
                >
                  <SearchIcon />
                </IconButton>
              </div>
            )}

            {/* Login Button with Icon */}
            {!roleId && (
              <div style={{ marginLeft: "auto", flexShrink: 0 }}>
                <Tooltip title="Login">
                  <IconButton
                    onClick={handleViewMoreInfo}
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      color: "white",
                      borderRadius: "8px",
                      width: "40px",
                      height: "40px",
                    }}
                  >
                    <LoginIcon />
                  </IconButton>
                </Tooltip>
              </div>
            )}

          </div>

          {/* RIGHT SIDE: Desktop Search + Toggles */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px", // Thoda gap badhaya for clean look
              flexShrink: 0,
              opacity: isSearchOpenMobile ? 0 : 1,
              transition: "opacity 0.2s",
              marginLeft: "auto" // Right align force karne ke liye
            }}
          >
            {/* DESKTOP SEARCH BAR */}
            {isLoggedIn && (
              <div className="desktop-search-wrap">
                <Select
                  className="select-css"
                  maxMenuHeight={250}
                  placeholder="Select Product..."
                  name="documentType"
                  value={documentTypeSelected}
                  isDisabled={!isLoggedIn}
                  options={productsListForDppOptions}
                  onChange={(selectedOption) => handleDocumentTypeChange(selectedOption)}
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: "100%",
                    }),
                    control: (base, state) => ({
                      ...base,
                      backgroundColor: "rgba(255, 255, 255, 0.95)",
                      borderRadius: "8px",
                      border: state.isFocused ? "2px solid #ffffff" : "1px solid transparent",
                      boxShadow: state.isFocused ? "0 0 0 2px rgba(13, 178, 107, 0.2)" : "none",
                      padding: "0px", // Extra padding hatayi
                      minHeight: "36px", // Height set ki
                      cursor: "pointer",
                      "&:hover": {
                        borderColor: "rgba(255, 255, 255, 0.8)",
                      }
                    }),
                    menu: (base) => ({
                      ...base,
                      borderRadius: "8px",
                      overflow: "hidden",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                      marginTop: "6px",
                      border: "1px solid #e2e8f0",
                      zIndex: 9999, // Menu humesha upar rahe
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected ? "#0db26b" : state.isFocused ? "#eefbf4" : "transparent",
                      color: state.isSelected ? "white" : "#334155",
                      cursor: "pointer",
                      padding: "8px 12px",
                      fontSize: "14px",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "#0f172a",
                      fontSize: "14px",
                      fontWeight: 600
                    }),
                  }}
                />
              </div>
            )}

            {/* TOGGLE BUTTONS
            <div className="mobile-hide-toggle" style={{ display: "flex", gap: 6, border: "1px solid rgba(255,255,255,0.3)", padding: "4px", borderRadius: "8px", height: "36px" }}>
              <button type="button" aria-pressed={layout === "horizontal"} onClick={() => { setVerticleTab(false); setLayout("horizontal"); }} style={{ ...styles.toggleBtn(layout === "horizontal"), padding: "0 10px", fontSize: "13px", height: "100%" }}>
                Horizontal
              </button>
              <button type="button" aria-pressed={layout === "vertical"} onClick={() => { setVerticleTab(true); setLayout("vertical"); }} style={{ ...styles.toggleBtn(layout === "vertical"), padding: "0 10px", fontSize: "13px", height: "100%" }}>
                Vertical
              </button>
            </div> */}
          </div>

          {isLoggedIn && (
            <div className={`mobile-search-overlay ${isSearchOpenMobile ? "open" : ""}`}>
              <div style={{ flex: 1 }}>
                <Select
                  className="select-css"
                  maxMenuHeight={180}
                  menuPortalTarget={document.body}
                  placeholder="Search Product..."
                  name="documentTypeMobile"
                  value={documentTypeSelected}
                  isDisabled={!isLoggedIn}
                  options={productsListForDppOptions}
                  onChange={(selectedOption) => {
                    handleDocumentTypeChange(selectedOption);
                    setIsSearchOpenMobile(false);
                  }}
                  styles={{
                    container: (base) => ({ ...base, width: "100%" }),
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    singleValue: (provided) => ({ ...provided, color: "#605c5cc9" }),
                    placeholder: (provided) => ({ ...provided, color: "#605c5cc9" }),
                    input: (provided) => ({ ...provided, color: "#605c5cc9" }),
                    option: (provided) => ({ ...provided, color: "#605c5cc9" }),
                  }}
                />
              </div>
              <IconButton onClick={() => setIsSearchOpenMobile(false)} style={{ color: "white", flexShrink: 0 }}>
                <CloseIcon />
              </IconButton>
            </div>
          )}
        </div>


        {verticalTab ? (
          /* MOBILE RESPONSIVE VIEW */
          <DppmobileView
            mainData={mainData}
            treeMapData={treeMapData}
            productImage={productImage}
            dppId={documentTypeSelected?.value}
            dppCode={documentTypeSelected.label}
            hasIndustryId={hasIndustryId}
            hasBatteryIndustry={hasBatteryIndustry}
            hasSteelIndustry={hasSteelIndustry}
            loadDppSidebarSection={loadDppSidebarSection}
            fetchDppSectionService={fetchDppSectionService}
            baseUrl={baseUrl}
            roleName={roleName}
            jwtToken={jwtToken}
            handleDocumentClick={handleDocumentClick}
            handleViewMoreInfo={handleViewMoreInfo}
          />
        ) : (


          <DppDesktopView
            mainData={mainData}
            treeMapData={treeMapData}
            productImage={productImage}
            dppId={documentTypeSelected?.value}
            dppCode={documentTypeSelected.label}
            hasIndustryId={hasIndustryId}
            hasBatteryIndustry={hasBatteryIndustry}
            downloadReport={downloadReport}
            hasSteelIndustry={hasSteelIndustry}
            loadDppSidebarSection={loadDppSidebarSection}
            fetchDppSectionService={fetchDppSectionService}
            baseUrl={baseUrl}
            roleName={roleName}
            jwtToken={jwtToken}
            handleDocumentClick={handleDocumentClick}
            handleViewMoreInfo={handleViewMoreInfo}
          />



        )}
        <style>{`
                    /* Mobile-first slider (hidden on desktop). Keeps content accessible and fully responsive. */
                    .plg-mobile-slider { display: block; padding: 10px 6px 18px; }
                    .plg-mobile-track {
                        display: flex;
                        gap: 12px;
                        overflow-x: auto;
                        padding: 6px;
                        scroll-snap-type: x mandatory;
                        -webkit-overflow-scrolling: touch;
                    }
                    .plg-mobile-step {
                        scroll-snap-align: center;
                        min-width: 240px;
                        max-width: 100%;
                        background: #fff;
                        border-radius: 12px;
                        padding: 12px;
                        display: flex;
                        gap: 6px;
                        align-items: center;
                        box-shadow: 0 8px 20px rgba(2,6,23,0.04);
                        flex-shrink: 0;
                    }
                    .plg-mobile-icon {
                        width: 56px;
                        height: 56px;
                        border-radius: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        font-weight: 700;
                        flex: 0 0 56px;
                        box-shadow: 0 6px 14px rgba(2,6,23,0.08), inset 0 3px 0 rgba(255,255,255,0.08);
                    }
                    .plg-mobile-step-number {
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        background: rgba(255,255,255,0.18);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 700;
                        color: #fff;
                        font-size: 13px;
                    }
                    .plg-mobile-card { display: flex; flex-direction: column; gap: 6px; }
                    .plg-mobile-title { font-size: 14px; font-weight: 600; color: #0f172a; }
                    .plg-mobile-pill {
                        display: inline-block;
                        padding: 6px 8px;
                        border-radius: 999px;
                        font-size: 12px;
                        border: 2px solid;
                        background: rgba(255,255,255,0.98);
                        font-weight: 600;
                        width: fit-content;
                    }
 
                    @media (max-width: 900px) {
                        .steps { display: none !important; }
                        .timeline-line { display: none !important; }
                    }

                    /* On larger screens hide the mobile slider */
                    @media (min-width: 901px) {
                        .plg-mobile-slider { display: none !important; }
                    }

                    /* Extra polish for very small devices */
                    @media (max-width: 420px) {
                        .plg-mobile-step { min-width: 200px; padding: 10px; gap: 10px; }
                        .plg-mobile-icon { width: 48px; height: 48px; flex: 0 0 48px; }
                        .plg-mobile-step-number { width: 28px; height: 28px; font-size: 12px; }
                    }
                        @media (max-width: 480px) {
              .details-row { 
                flex-direction: column; 
                gap: 4px; 
                align-items: flex-start; 
              }
              .detail-value { 
                text-align: left; 
                max-width: 100%; 
              }
            }
                `}</style>

        <style>{`
                .plg-container {
                    font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
                    background: "white" ;
                    border: 1px solid rgba(59,130,246,0.08);
                    border-radius: 12px;
                    padding: 20px;
                    box-shadow: 0 6px 18px rgba(2,6,23,0.06);
                }
                .plg-header h3 { margin: 0; font-size: 18px; color: #0f172a; }
                .plg-header small { color: #6b7280; }

                .timeline-wrap { position: relative; margin-top: 20px; padding: 36px 12px 20px; background: transparent; }
                .timeline-line {
                    position: absolute;
                    left: 48px;
                    right: 48px;
                    top: 72px;
                    height: 6px;
                    background: linear-gradient(90deg,#bbdefb,#c8f7e6);
                    border-radius: 4px;
                    filter: blur(0.2px);
                }


.hl-connector {
  width: 2px;
  height: 82px;          
  background: rgba(16, 185, 129, 0.30);
               }       
                .steps {
                    display: flex;
                    gap: 40px;
                    align-items: flex-start;
                    justify-content: space-between;
                    position: relative;
                }
                .step {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: "300px";
                    min-width: 170px;
                    z-index: 0;
                }

                .icon-wrap { position: relative; margin-bottom: 12px; }
                .icon-circle {
                    width: 86px;
                    height: 86px;
                    border-radius: 50%;
                    background: linear-gradient(180deg,#05b85b,#00b74a);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 6px 20px rgba(3,102,67,0.12), inset 0 4px 0 rgba(255,255,255,0.12);
                }
                .icon-circle svg { display: block; }

                .step-number {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    background: #fff;
                    border: 3px solid rgba(99,102,241,0.8);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 600;
                    color: #374151;
                    box-shadow: 0 4px 10px rgba(2,6,23,0.08);
                }

                .card {
                    margin-top: 12px;
                    background: #fff;
                    width: "fit-content";
                    border-radius: 10px;
                    padding: 6px 12px;
                    box-shadow: 0 8px 20px rgba(2,6,23,0.04);
                    text-align: center;
                }
                .card-title { color: #0f172a; font-weight: 600; margin-bottom: -5px; font-size: 14px; width: fit-content; margin-left: auto; margin-right: auto; }
                .pill {
                    display: inline-block;
                    padding: 5px;
                    border-radius: 5px;
                    font-size: 12px;
                    border: 2px solid;
                    background: rgba(255,255,255,0.98);
                    font-weight: 600;
                }

                /* responsive */
                @media (max-width: 900px) {
                    .steps { gap: 24px; overflow-x: auto; padding-bottom: 8px; }
                    .timeline-line { left: 16px; right: 16px; top: 116px; }
                }
            `}</style>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Document View</DialogTitle>
        <DialogContent>
          <Card
            sx={{
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.02)",
              },
              width: "100%",
              maxWidth: "1000px",
            }}
          >
            {isLoading && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <CircularProgress />
              </div>
            )}

            {isPDF ? (
              <iframe
                src={selectedDocumentUrl}
                title="VIEW"
                width="100%"
                height="800px"
                style={{
                  border: "none",
                  borderRadius: "16px",
                  boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.2)",
                  position: "relative",
                }}
                onLoad={handleIframeLoad}
              />
            ) : (
              <img
                src={selectedDocumentUrl}
                alt="VIEW"
                width="100%"
                style={{
                  borderRadius: "16px",
                  boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.2)",
                  transition: "all 0.3s ease-in-out",
                }}
              />
            )}
          </Card>
        </DialogContent>

        <DialogActions sx={{ padding: "16px", justifyContent: "center", gap: "16px" }}>
          <MDButton
            onClick={handleCloseDialog}
            color="primary"
            variant="contained"
            sx={{
              fontSize: "1rem",
              padding: "8px 24px",
              backgroundColor: "#007BFF",
              "&:hover": {
                backgroundColor: "#0056b3",
              },
            }}
          >
            Close
          </MDButton>

          {downloadUrl && (
            <MDButton
              color="info"
              variant="contained"
              onClick={async () => {
                try {
                  const response = await fetch(downloadUrl);
                  const blob = await response.blob();
                  const blobUrl = window.URL.createObjectURL(blob);

                  const link = document.createElement('a');
                  link.href = blobUrl;

                  const fileName = downloadUrl.split('/').pop().split('?')[0] || 'document';
                  link.setAttribute('download', fileName);

                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(blobUrl);
                } catch (error) {
                  window.open(downloadUrl, "_blank");
                }
              }}
              sx={{
                fontSize: "1rem",
                padding: "8px 24px",
              }}
            >
              Download
            </MDButton>
          )}
        </DialogActions>

      </Dialog>


      <Dialog
        open={openViewItemsModal}
        onClose={handleCloseViewItemsModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {(testType == "tensileTest" && "Tensile Test") ||
            (testType == "hardnessTest" && "Hardness Test") ||
            (testType == "notchimpactTest" && "Notch Impact Test") ||
            (testType == "textileTest" && "Textile Test") ||
            (testType == "thermalStability" && "Thermal Stability Test") ||
            (testType == "shortCircuitOverchargeTest" && "Short Circuit & Overcharge Test")

          }

        </DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              marginTop: 16,
            }}
          >
            {/* Test Yield Name */}
            {viewItemsData?.yiTestName && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Yield Test Name
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.yiTestName || "—"}
                </div>
              </div>
            )}
            {viewItemsData?.abrasionResistance && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Abrasion Resistance
                </div>

                {/* <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.abrasionResistance || "—"}
                </div> */}

                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {" "}
                  {viewItemsData?.abrasionResistance
                    ? `${viewItemsData.abrasionResistance} Cycles`
                    : "—"}{" "}
                </div>
              </div>
            )}



            {testType === "thermalStability" && viewItemsData && (
              <>


                {viewItemsData.testResult && (
                  <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Test Result</div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{viewItemsData.testResult}</div>
                  </div>
                )}

                {viewItemsData.minOperatingTemp && (
                  <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Min Operating Temp</div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{viewItemsData.minOperatingTemp}</div>
                  </div>
                )}

                {viewItemsData.maxOperatingTemp && (
                  <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Max Operating Temp</div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{viewItemsData.maxOperatingTemp}</div>
                  </div>
                )}

                {viewItemsData.thermalStabilityTestTemp && (
                  <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Thermal Stability Test Temp</div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{viewItemsData.thermalStabilityTestTemp}</div>
                  </div>
                )}

                {viewItemsData.thermalRunawayOnsetTemp && (
                  <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Thermal Runaway Onset Temp</div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{viewItemsData.thermalRunawayOnsetTemp}</div>
                  </div>
                )}

                {viewItemsData.temperatureRise && (
                  <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Temperature Rise</div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{viewItemsData.temperatureRise}</div>
                  </div>
                )}

                {viewItemsData.thermalExposureDuration && (
                  <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Thermal Exposure Duration</div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{viewItemsData.thermalExposureDuration}</div>
                  </div>
                )}



                {/* {viewItemsData.description && (
                  <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Description</div>
                    <div style={{ fontWeight: 500, color: "#0f172a", lineHeight: 1.4 }}>{viewItemsData.description}</div>
                  </div>
                )} */}
              </>
            )}


            {viewItemsData?.overchargeTest && (
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                  Overcharge Test
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.overchargeTest || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.overchargeTestValue && (
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                  Overcharge Test Value
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.overchargeTestValue || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.shortCircuitTest && (
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                  Short Circuit Test
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.shortCircuitTest || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.shortCircuitTestValue && (
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                  Short Circuit Test Value
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.shortCircuitTestValue || "—"}
                </div>
              </div>
            )}

            {/* {viewItemsData?.description && testType === "shortCircuitOverchargeTest" && (
                <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                    Description
                  </div>
                  <div style={{ fontWeight: 500, color: "#0f172a", lineHeight: 1.4 }}>
                    {viewItemsData?.description || "—"}
                  </div>
                </div>
              )} */}

            {viewItemsData?.pillingResistance && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Pilling Resistance
                </div>
                {/* <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.pillingResistance || "—"}
                </div> */}

                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {" "}
                  {viewItemsData?.pillingResistance
                    ? `${viewItemsData.pillingResistance} %`
                    : "—"}{" "}
                </div>
              </div>
            )}
            {viewItemsData?.colorFastness && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Color Fastness
                </div>
                {/* <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.colorFastness || "—"}
                </div> */}

                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.colorFastness
                    ? `${viewItemsData.colorFastness} / 5`
                    : "—"}
                </div>
              </div>
            )}
            {viewItemsData?.shrinkagePercentage && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Shrinkage Percentage
                </div>

                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {" "}
                  {viewItemsData?.shrinkagePercentage
                    ? `${viewItemsData.shrinkagePercentage} %`
                    : "—"}{" "}
                </div>
              </div>
            )}

            {/* Yield Methodology */}
            {viewItemsData?.yiMethodology && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Yield Methodology
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.yiMethodology || "—"}
                </div>
              </div>
            )}

            {/* Tensile Test Name */}
            {viewItemsData?.teTestName && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Tensile Test Name
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.teTestName || "—"}
                </div>
              </div>
            )}

            {/* Tensile Strength Mean */}
            {viewItemsData?.tensileStrengthMean && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Tensile Strength Mean
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.tensileStrengthMean || "—"}
                </div>
              </div>
            )}

            {/* Hardness Test Name */}
            {viewItemsData?.hrTestName && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Hardness Test Name
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hrTestName || "—"}
                </div>
              </div>
            )}

            {/* {viewItemsData?.hardnessMean && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Hardness Mean
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hardnessMean || "—"}
                </div>
              </div>
            )} */}

            {/* Hardness Mean */}
            {viewItemsData?.hardnessMean !== undefined && (
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                  Hardness Mean
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hardnessMean}
                </div>
              </div>
            )}

            {/* Hardness Individual Values */}
            {viewItemsData?.hardnessIndividualValues !== undefined && (
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                  Hardness Individual Values
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hardnessIndividualValues}
                </div>
              </div>
            )}

            {viewItemsData?.imTestName && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact Test Name
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.imTestName || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.notchimpactStrengthMean && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Notch Impact Strength Mean
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.notchimpactStrengthMean || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.impactLL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact LL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.impactLL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.impactUL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact UL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.impactUL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.impactUOM && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact UOM
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.impactUOM || "—"}
                </div>
              </div>
            )}
            {viewItemsData?.yeildProofStrengthMean && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Yield Proof Strength Mean
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.yeildProofStrengthMean || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.yieldLL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Yield LL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.yieldLL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.yieldUL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Yield UL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.yieldUL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.yieldUOM && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Yield UOM
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.yieldUOM || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.teMethodology && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Tensile Methodology
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.teMethodology || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.tensileLL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Tensile LL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.tensileLL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.tensileUL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Tensile UL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.tensileUL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.tensileUOM && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Tensile UOM
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.tensileUOM || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.imMethodology && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact Methodology
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.imMethodology || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.impactLL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact LL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.impactLL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.impactUL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact UL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.impactUL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.impactUOM && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact UOM
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.impactUOM || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hrMethodology && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  HR Methodology
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hrMethodology || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hrcLL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  HRC LL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hrcLL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hrcUL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  HRC UL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hrcUL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hrUOM && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  HR UOM
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hrUOM || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hbTestName && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  HB Test Name
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hbTestName || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hbMethodology && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  HB Methodology
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hbMethodology || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hardnessIndividualValues && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Hardness Individual Values
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hardnessIndividualValues || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hbLL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  HB LL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hbLL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hbUL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  HB UL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hbUL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.hbUOM && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  HB UOM
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.hbUOM || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.impactTestName && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact Test Name
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.impactTestName || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.impactMethodology && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  Impact Methodology
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.impactMethodology || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.chLL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  CH LL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.chLL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.chUL && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  CH UL
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.chUL || "—"}
                </div>
              </div>
            )}

            {viewItemsData?.chUOM && (
              <div
                style={{
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 4,
                  }}
                >
                  CH UOM
                </div>
                <div style={{ fontWeight: 700, color: "#0f172a" }}>
                  {viewItemsData?.chUOM || "—"}
                </div>
              </div>
            )}
          </div>
        </DialogContent>

        <DialogActions>
          <MDButton
            onClick={handleCloseViewItemsModal}
            color="info"
            variant="contained"
            sx={{
              display: "block",
              margin: "0 auto",
            }}
          >
            Close
          </MDButton>
        </DialogActions>
      </Dialog>


      {/* </DashboardLayout> */}
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    // getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getProductsListForDppReducer: state.getProductsListForDppReducer,
    getAllDataForDppReducer: state.getAllDataForDppReducer,
    getTechnicalDocumentsReducer: state.getTechnicalDocumentsReducer,
    getDurabilityReducer: state.getDurabilityReducer,
    getRepairMaintenanceReducer: state.getRepairMaintenanceReducer,
    getManufacturingReducer: state.getManufacturingReducer,
    getChainOfCustodyReducer: state.getChainOfCustodyReducer,
    getEnvironmentalReducer: state.getEnvironmentalReducer,
    getRawMaterialReducer: state.getRawMaterialReducer,
    getPackagingWasteManagementReducer:
      state.getPackagingWasteManagementReducer,
    getItemsDetailsByDppIdReducer: state.getItemsDetailsByDppIdReducer,
    // getUsageHistoryReducer: state.getUsageHistoryReducer,
    getTreeMapReducer: state.getTreeMapReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // getSubModulesByRoleId: (roleId, jwtToken) =>
    //   dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getProductsListForDpp: (jwtToken) =>
      dispatch(getProductsListForDpp(jwtToken)),
    getAllDataForDpp: (dppCode, jwtToken) =>
      dispatch(getAllDataForDpp(dppCode, jwtToken)),
    getTechnicalDocuments: (dppId, jwtToken) =>
      dispatch(getTechnicalDocuments(dppId, jwtToken)),
    getDurability: (dppId, jwtToken) =>
      dispatch(getDurability(dppId, jwtToken)),

    getRepairMaintenance: (dppId, jwtToken) =>
      dispatch(getRepairMaintenance(dppId, jwtToken)),

    getManufacturing: (dppId, jwtToken) =>
      dispatch(getManufacturing(dppId, jwtToken)),

    getChainOfCustody: (dppId, jwtToken) =>
      dispatch(getChainOfCustody(dppId, jwtToken)),

    getEnvironmental: (dppId, jwtToken) =>
      dispatch(getEnvironmental(dppId, jwtToken)),

    getRawMaterial: (dppId, jwtToken) =>
      dispatch(getRawMaterial(dppId, jwtToken)),
    getPackagingWasteManagement: (dppId, jwtToken) =>
      dispatch(getPackagingWasteManagement(dppId, jwtToken)),

    getItemsDetailsByDppId: (dppId, jwtToken) =>
      dispatch(getItemsDetailsByDppId(dppId, jwtToken)),
    getTreeMap: (dppId, jwtToken) => dispatch(getTreeMap(dppId, jwtToken)),


    // getUsageHistory: (dppId, jwtToken) => dispatch(getUsageHistory(dppId, jwtToken)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DppLayout);